// src/pages/Contact.js
import { useState } from 'react';
import { FiMail, FiMapPin, FiClock, FiSend, FiFacebook } from 'react-icons/fi';
import FadeIn from '../components/FadeIn';

const INITIAL = { name: '', email: '', subject: '', message: '' };

function Contact() {
  const [form, setForm] = useState(INITIAL);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://formspree.io/f/xyknynvq', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('sent');
        setForm(INITIAL);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }

  const isValid = form.name && form.email && form.subject && form.message;

  return (
    <div className="contact-page">

      {/* ── Hero ── */}
      <section className="contact-hero">
        <FadeIn>
          <p className="offer-heading">Get in Touch</p>
          <h1 className="services-hero-title">Contact Us</h1>
          <p className="services-hero-body">
            Have a project in mind or want to learn more about what we offer?
            Drop us a message and we'll get back to you within one business day.
          </p>
        </FadeIn>
      </section>

      {/* ── Main ── */}
      <section className="contact-main">
        <div className="contact-inner">

          {/* Left — info */}
          <FadeIn>
            <aside className="contact-info">
              <h2 className="contact-info-title">Let's Talk</h2>
              <p className="contact-info-body">
                Whether you're starting from scratch or looking to level up an existing site,
                we'd love to hear about your vision.
              </p>

              <ul className="contact-details">
                <li className="contact-detail-item">
                  <span className="contact-detail-icon"><FiMail size={18} /></span>
                  <div>
                    <span className="contact-detail-label">Email</span>
                    <a href="mailto:owner@csdevs.com" className="contact-detail-value">owner@csdevs.com</a>
                  </div>
                </li>
                <li className="contact-detail-item">
                  <span className="contact-detail-icon"><FiMapPin size={18} /></span>
                  <div>
                    <span className="contact-detail-label">Location</span>
                    <span className="contact-detail-value">Remote — Worldwide</span>
                  </div>
                </li>
                <li className="contact-detail-item">
                  <span className="contact-detail-icon"><FiClock size={18} /></span>
                  <div>
                    <span className="contact-detail-label">Response Time</span>
                    <span className="contact-detail-value">Within 1 business day</span>
                  </div>
                </li>
              </ul>

              <div className="contact-social">
                <span className="contact-social-label">Follow Us</span>
                <div className="contact-social-icons">
                  <a href="https://www.facebook.com/profile.php?id=61570762256091" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FiFacebook size={18} /></a>
                </div>
              </div>
            </aside>
          </FadeIn>

          {/* Right — form */}
          <FadeIn delay={150}>
            <div className="contact-form-wrapper">
              {status === 'sent' ? (
                <div className="contact-success">
                  <FiSend size={32} className="contact-success-icon" />
                  <h3>Message Sent!</h3>
                  <p>Thanks for reaching out. We'll be in touch shortly.</p>
                  <button className="btn-cta" onClick={() => setStatus('idle')}>
                    Send Another
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit} noValidate>
                  <h2 className="contact-form-title">Send a Message</h2>

                  <div className="contact-form-row">
                    <div className="form-field">
                      <label className="form-label" htmlFor="cf-name">Name</label>
                      <input
                        id="cf-name"
                        className="form-input"
                        type="text"
                        name="name"
                        placeholder="Jane Smith"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label className="form-label" htmlFor="cf-email">Email</label>
                      <input
                        id="cf-email"
                        className="form-input"
                        type="email"
                        name="email"
                        placeholder="jane@example.com"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-field">
                    <label className="form-label" htmlFor="cf-subject">Subject</label>
                    <input
                      id="cf-subject"
                      className="form-input"
                      type="text"
                      name="subject"
                      placeholder="I'd like to discuss a project…"
                      value={form.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-field">
                    <label className="form-label" htmlFor="cf-message">Message</label>
                    <textarea
                      id="cf-message"
                      className="form-input form-textarea contact-textarea"
                      name="message"
                      placeholder="Tell us about your project, timeline, and budget…"
                      value={form.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn-cta contact-submit"
                    disabled={!isValid || status === 'sending'}
                  >
                    {status === 'sending' ? 'Sending…' : (
                      <><FiSend size={14} /> Send Message</>
                    )}
                  </button>
                  {status === 'error' && (
                    <p className="contact-error">Something went wrong. Please try again or email us directly.</p>
                  )}
                </form>
              )}
            </div>
          </FadeIn>

        </div>
      </section>

    </div>
  );
}

export default Contact;
